import { FONTS, COLORS } from '../../../../../../constants';

const styles = theme => {
  const minSm = theme.breakpoints.up('sm');
  const minMd = theme.breakpoints.up('md');

  return {
    root: {
      backgroundColor: COLORS.GREY_DARK,
    },
    inner: {
      margin: '0 auto',
      maxWidth: 1200,
      padding: '40px 20px',
      [minMd]: {
        padding: '40px 30px',
      },
    },
    instruction: {
      color: COLORS.WHITE,
      fontSize: '1rem',
      textAlign: 'center',
      fontFamily: FONTS.SECONDARY,
      lineHeight: 1.4,
      [minSm]: {
        fontSize: '1.25rem',
      },
    },
  };
};

export default styles;
